<div class="flex flex-col gap-2">
  @if (label()) {
    <label class="truncate" [ngClass]="smallLabel() ? 'text-sm' : ''" [for]="id()">
      {{ label() | transloco }}
      @if (isRequired()) {
        <span class="text-red" [ngClass]="smallLabel() ? 'text-sm' : ''">*</span>
      }
      @if (tooltipKey()) {
        <app-directus-tooltip class="ml-2" [tooltipKey]="tooltipKey()" />
      }
      <ng-content select="[labelBadge]" />
    </label>
  }

  <div
    [ngClass]="{
      'p-inputgroup w-full': !!icon(),
      'icon-end': !!icon() && iconPosition() === IconPosition.End,
    }"
  >
    @if (icon() && iconPosition() === IconPosition.Begin) {
      <span class="p-inputgroup-addon">
        <i [class]="icon()"></i>
      </span>
    }

    @if (isReadOnly()) {
      <input
        pInputText
        [value]="formattedReadOnlyValue()"
        [disabled]="true"
        class="w-full"
        [ngClass]="[icon() ? 'readOnlyWithIcon' : 'readOnly', alignRight() ? 'text-right' : '']"
      />
    } @else {
      <p-inputNumber
        [id]="id()"
        [attr.data-testid]="id() + '-input'"
        [(ngModel)]="value"
        [min]="finalMin()"
        [max]="finalMax()"
        [showButtons]="showButtons()"
        [showClear]="showClear()"
        [step]="step() ?? finalMin()"
        [locale]="effectiveLocale()"
        [mode]="mode() === 'decimal' ? 'decimal' : undefined"
        [minFractionDigits]="mode() === 'decimal' ? minFractionDigits() : undefined"
        [maxFractionDigits]="mode() === 'decimal' ? maxFractionDigits() : undefined"
        [inputStyleClass]="alignRight() ? 'text-right' : ''"
        [placeholder]="placeholder() || (label() | transloco)"
        [invalid]="isInvalid()"
        fluid="true"
        (onBlur)="markAsTouched()"
      >
      </p-inputNumber>
    }

    @if (icon() && iconPosition() === IconPosition.End) {
      <span class="p-inputgroup-addon">
        <i [class]="icon()"></i>
      </span>
    }
  </div>
</div>
